export default __webpack_public_path__ + "static/media/bulb.2415cde0.svg";